<template>
    <DxDataGrid :data-source="dsSarbatoriLegale" ref="dataGridRef" :allow-column-reordering="false" :allow-column-resizing="true" :column-auto-width="false"
        :show-borders="true" key-expr="Id">
        <DxSelection mode="single" />
        <DxFilterRow :visible="false" />
        <DxPaging :page-size="10" :page-index="0" />
        <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
        <DxSorting mode="multiple" />
        <DxSearchPanel :visible="true" :width="240" placeholder='Cauta ...'></DxSearchPanel>
        <DxEditing :allow-updating="true" :allow-deleting="true" mode="popup">
            <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" :width="500" :height="350" :show-title="true" title-template="editTitle">
                <DxToolbarItem toolbar="bottom" widget="dxButton" location="center" :options="saveButtonOptions" />
                <DxToolbarItem toolbar="bottom" widget="dxButton" location="center" :options="dangerButtonOptions" />
            </DxPopup>
            <DxFormGrid>
                <DxItem data-field="Nume"/>
                <DxItem data-field="Data"/>
                <DxItem data-field="InceputIntervalValabilitate"/>
                <DxItem data-field="SfarsitIntervalValabilitate"/>
                <DxItem data-field="Anuala" editor-type="dxCheckBox" :css-class="'checkbox-center'" :editor-options="{ elementAttr: { style: 'display:flex; justify-content:center; margin-left:120px' } }"/>
            </DxFormGrid>
        </DxEditing>    
        <template #editTitle>
            <div style="background-color:#ff2c21; font-size:15px; color:white; font-weight:bold; padding:10px 0 10px 20px; width:100%;">
                Editare Sărbătoare Legală
            </div>
        </template>

        <DxColumn data-field="Nume" caption="Nume"/>
        <DxColumn data-field="Data" caption="Data"/>
        <DxColumn data-field="Anuala" caption="Anuala?"/>
        <DxColumn data-field="InceputIntervalValabilitate" caption="Inceput Interval Valabilitate"/>
        <DxColumn data-field="SfarsitIntervalValabilitate" caption="Sfarsit Interval valabilitate"/> 

        <DxToolbar>
            <DxItem location="after" name="searchPanel"/>
            <DxItem>
                <template #default>
                    <DxButton icon="add" type="success" @click="onAddClick" />
                </template>
            </DxItem>
            <DxItem>
                <template #default>
                    <DxButton icon="refresh" @click="onRefreshClick" />
                </template>
            </DxItem>
        </DxToolbar>
    </DxDataGrid>
    <DxPopupAdd :visible="addPopupVisible" :show-title="true" width="500" height="350">
        <template #title>
            <div style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
                Adăugare Sărbătoare Legală
            </div>
        </template>
        <DxForm :col-count="2" :data-source="newSarbatoareLegala">
            <DxSimpleItem data-field="Nume" :is-required="true">
                <template #default>
                    <DxTextArea :value="newSarbatoareLegala.Nume" @value-changed="onNumeValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Data" :is-required="true">
                <template #default>
                    <DxDateBox v-model:value="newSarbatoareLegala.Data" type="date" display-format="dd-MM-yyyy" :show-clear-button="true" label-mode="floating" height="50px"/> 
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Inceput Interval Valabilitate">
                <template #default>
                    <DxDateBox :value="newSarbatoareLegala.InceputIntervalValabilitate" type="date" display-format="dd-MM-yyyy" :show-clear-button="true" 
                    label-mode="floating" height="50px" :max="newSarbatoareLegala.SfarsitIntervalValabilitate" @value-changed="onInceputValabilitateChanged"/> 
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Sfarsit Interval Valabilitate">
                <template #default>
                    <DxDateBox :value="newSarbatoareLegala.SfarsitIntervalValabilitate" type="date" display-format="dd-MM-yyyy" :show-clear-button="true" 
                    label-mode="floating" height="50px" :min="newSarbatoareLegala.InceputIntervalValabilitate" @value-changed="onSfarsitValabilitateChanged"/> 
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Anuala?" :is-required="true" :col-span="2">
                <template #default>
                    <div style="display: flex; justify-content: center;">
                        <DxCheckBox :value="newSarbatoareLegala.Anuala" @value-changed="onAnualaValueChanged" />
                    </div>
                </template>
            </DxSimpleItem>
        </DxForm>
        <DxToolbarItem widget="dxButton" toolbar="bottom" location="center" :options="addButtonOptions"/>
        <DxToolbarItem widget="dxButton" toolbar="bottom" location="center" :options="closeButtonOptions"/>
    </DxPopupAdd>
</template>
<script lang="ts">
    import {
        DxColumn,
        DxDataGrid,
        DxFilterRow,
        DxLoadPanel,
        DxPaging,
        DxSelection,
        DxSorting,
        DxStateStoring,
        DxToolbar,
        DxEditing,
        DxPopup,
        DxItem,
        DxItem as DxFormItem,
        DxForm as DxFormGrid,
        DxValidationRule,
        DxRequiredRule,
        DxSearchPanel,
        DxSearch,
    } from 'devextreme-vue/data-grid';
    import DxDateBox from 'devextreme-vue/date-box';
    import { DxCheckBox } from 'devextreme-vue/check-box';
    import DxTextArea from 'devextreme-vue/text-area';
    import ODataStore from 'devextreme/data/odata/store';
    import AppSetting from '@/settings/appSettings';
    import { defineComponent, ref } from 'vue';
    import DataSource from 'devextreme/data/data_source';
    import { DxButton } from 'devextreme-vue/button';
    import notify from 'devextreme/ui/notify';
    import { DxForm, DxSimpleItem } from "devextreme-vue/form"
    import DxPopupAdd from 'devextreme-vue/popup'
    import { DxToolbarItem } from 'devextreme-vue/popup';
    import RU_SarbatoriLegale from '@/services/RU/RU_SarbatoriLegale';

    export default defineComponent({
        components: {
            DxColumn,
            DxDataGrid,
            DxFilterRow,
            DxLoadPanel,
            DxPaging,
            DxSelection,
            DxSorting,
            DxStateStoring,
            DxToolbar,
            DxEditing,
            DxValidationRule,
            DxRequiredRule,
            DxItem,
            DxButton,
            DxSearchPanel,
            DxForm,
            DxPopupAdd,
            DxSimpleItem,
            DxTextArea,
            DxCheckBox,
            DxToolbarItem,
            DxPopup,
            DxFormGrid,
            DxFormItem,
            DxDateBox
        },
        data() {
            return {
                dsSarbatoriLegale: {} as DataSource,
                dataGridRef: ref<DxDataGrid | null>(null),
                deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",
                addPopupVisible: false,
                newSarbatoareLegala: {
                    Nume: '',
                    Data: null,
                    Anuala: null,
                    InceputIntervalValabilitate: null,
                    SfarsitIntervalValabilitate: null
                },
                addButtonOptions: {
                    type: "success", 
                    text: "Salvează", 
                    stylingMode: "contained",
                    onClick: () => {
                        this.onSaveAdd()
                    }
                },
                saveButtonOptions: {
                    type: "success", 
                    text: "Salvează", 
                    stylingMode: "contained",
                    onClick: () => {
                        this.onSaveEdit()
                    }
                },
                closeButtonOptions: {
                    type: "danger", 
                    text: "Închide", 
                    stylingMode: "contained",
                    onClick: () => {
                        this.onCloseAdd()
                    }
                },
                dangerButtonOptions: {
                    type: "danger", 
                    text: "Închide", 
                    stylingMode: "contained",
                    onClick: () => {
                        this.closeEditPopup()
                    }
                },
            }

        },
        mounted() {
            this.dsSarbatoriLegale = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ResurseUmaneOdata + `RU_SarbatoriLegale`,
                    key: 'Id',
                    keyType: "Guid",
                    version: 4,
                    beforeSend: (e: any) => {
                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                        };
                    },
                },
            })
            this.dataGridRef = this.$refs.dataGridRef as DxDataGrid;
            this.setDeleteConfirmationMessage()
        },
        methods: {
            setDeleteConfirmationMessage() {
                const dataGrid = this.$refs.dataGridRef?.instance;
                dataGrid.option('editing', {
                    allowUpdating: true,
                    allowDeleting: true,
                    mode: 'popup',
                    texts: {
                        confirmDeleteMessage: this.deleteConfirmationMessage,
                        confirmDeleteTitle: "Confirmare Ștergere",
                    }
                });
            },
            onRefreshClick() {
                const gridInstance = this.dataGridRef?.instance;
                if (gridInstance) {
                    gridInstance.refresh();
                    notify("Datele au fost actualizate cu succes!", "success", 3000);
                }
            },
            onAddClick() {
                this.addPopupVisible = true
            },
            onCloseAdd() {
                this.addPopupVisible = false
                this.newSarbatoareLegala.Nume = ''
                this.newSarbatoareLegala.Data = null
                this.newSarbatoareLegala.InceputIntervalValabilitate = null
                this.newSarbatoareLegala.SfarsitIntervalValabilitate = null
                this.newSarbatoareLegala.Anuala = false
            },
            onNumeValueChanged(e: any) {
                this.newSarbatoareLegala.Nume = e.value
            },
            onAnualaValueChanged(e: any) {
                this.newSarbatoareLegala.Anuala = e.value
            },
            onSaveAdd() {
                if (!this.newSarbatoareLegala.Nume || this.newSarbatoareLegala.Nume.trim() === "") {
                    notify("Va rog sa completati campul obligatoriu 'Nume'!", 'error', 3000)
                    return
                }

                if (this.newSarbatoareLegala.Data === null) {
                    notify("Va rog sa completati campul obligatoriu 'Data'!", 'error', 3000)
                    return
                }

                if (this.newSarbatoareLegala.Anuala === null) {
                    notify("Va rog sa completati campul obligatoriu 'Anuala?'!", 'error', 3000)
                    return
                }

                RU_SarbatoriLegale.save(this.newSarbatoareLegala).then((sarbatoare) => {
                    this.addPopupVisible = false
                    notify('Datele au fost salvate cu succes!', 'success', 2000)
                    this.newSarbatoareLegala = {
                        Nume: '',
                        Data: null,
                        Anuala: null,
                        InceputIntervalValabilitate: null,
                        SfarsitIntervalValabilitate: null
                    }
                    this.onRefreshClick()
                }).catch((error) => {
                    console.error(error)
                    notify("Datele exista deja!", 'error', 3000)
                })
            },
            closeEditPopup() {
                this.dataGridRef?.instance?.cancelEditData();
            },
            async onSaveEdit() {
                const gridInstance = this.dataGridRef?.instance;
                if (!gridInstance) {
                    notify('Eroare: Grila nu este încărcată.', 'error', 2000);
                    return; 
                }
                try {
                    gridInstance.saveEditData()
                    notify('Datele au fost salvate cu succes!', 'success', 2000);
                } catch (error: any) {
                    console.error("Eroare la salvarea editării:", error);
                }
            },
            onInceputValabilitateChanged(e: any) {
                this.newSarbatoareLegala.InceputIntervalValabilitate = e.value
            },
            onSfarsitValabilitateChanged(e: any) {
                this.newSarbatoareLegala.SfarsitIntervalValabilitate = e.value
            },
        },
    })
</script>
<style scoped>
.circle-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.circle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
}

.circle-true {
  background-color: #4caf50;
  color: white;
}

.circle-false {
  border: 2px solid #aaa;
}

.checkbox-center .dx-field-item-content {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left:110px;
  margin-top: 30px;
}
</style>